'use client';
import { event_button_click } from '@/utils/gtm';
import NextLink from '@/components/next-link';
import { useLocale } from 'next-intl';
import Image from 'next/image';

const Logo = () => {
  const locale = useLocale();
  const logoPath = locale === 'ar'
      ? '/imgs/logo-ar.png'
      : '/imgs/logo-en.png';
  return (
    <NextLink
      href='/'
      onClick={() =>
        event_button_click({
          button_name: 'Logo',
          button_destination: '/',
          button_location: 'header',
        })
      }
    >
      <Image
        src={logoPath}
        alt='Inovva Logo'
        loading='eager'
        property='true'
        className='h-auto max-sm:h-7.5 object-contain  w-20 lg:w-[117px]'
        height={39}
        width={117}
      />
    </NextLink>
  );
};

export default Logo;
